// extracted by mini-css-extract-plugin
export var anchor = "dark-with-image-below-physiolymp-module--anchor--s9RbT";
export var container = "dark-with-image-below-physiolymp-module--container--0n79N";
export var dimmedTitle = "dark-with-image-below-physiolymp-module--dimmed-title--xDvkW";
export var image = "dark-with-image-below-physiolymp-module--image--VPnEv";
export var text = "dark-with-image-below-physiolymp-module--text--xEPxc";
export var title = "dark-with-image-below-physiolymp-module--title--HayvG";